import React, { createContext } from 'react';

import type { BackBehaviorOverrideContextValue } from './BackBehaviorOverrideContextValue';
import { backBehaviorOverrideDefaultValue } from './backBehaviorOverrideDefaultValue';

export const BackBehaviorOverrideContext: React.Context<BackBehaviorOverrideContextValue> =
	createContext<BackBehaviorOverrideContextValue>(backBehaviorOverrideDefaultValue);
